import { Layout } from "antd";

function Footer() {
  
  const { Footer: AntFooter } = Layout;

  const currentYear = new Date().getFullYear();

  return (
    <AntFooter>
      <div className="copyright">
        <div> Copyright © {currentYear}. All Rights Reserved </div>
        <div> Gearbox </div>
      </div>
    </AntFooter>
  );
}

export default Footer;